(function (w) {
	'use strict';

	function mxSearchHotkeysManager() {
		var listItemSelected, listItems;
		var search;
		var elements = {
			getListItems: function () {
				return elements.list.find('md-list-item');
			},
			getSelectedListItem: function () {
				return elements.list.find('md-list-item.selected');
			},
		};

		var handle = {
			// Arrow down
			40: handleArrowDown,
			// Arrow  up
			38: handleArrowUp,
			// Tab
			9: handleTab,
			// Arrow right
			39: handleArrowRight,
			// Enter
			13: handleEnter,
			// Backspace
			8: handleBackspace,
			// Esc
			27: handleEsc,
		};

		return { init: init };

		function init(s, $element) {
			search = s;

			elements.searchPanel = $element.find('.mx-search__panel');
			elements.list = $element.find('.mx-search__list');
			elements.input = $element.find('md-input-container input');

			if (search) {
				elements.searchPanel.bind('keydown', function (event) {
					if (handle.hasOwnProperty(event.which)) {
						handle[event.which]();
					}
				});

				elements.input.bind('keyup', handleInput);
			}
		}

		function handleInput(event) {
			switch (event.which) {
				case 40:
				case 38:
				case 9:
				case 39:
				case 27:
					event.preventDefault();
					break;
				case 13:
					handleEnter();
					break;
			}
		}

		function handleArrowDown() {
			listItemSelected = elements.getSelectedListItem();
			listItems = elements.getListItems();

			if (listItemSelected.length !== 0) {
				listItemSelected.removeClass('selected');
				var nextItem = listItemSelected.nextAll('md-list-item').eq(0);

				if (nextItem.length > 0) {
					listItemSelected = nextItem.addClass('selected');
				} else {
					listItemSelected = listItems.eq(0).addClass('selected');
				}
			} else {
				listItemSelected = listItems.eq(0).addClass('selected');
			}
		}

		function handleArrowUp() {
			listItemSelected = elements.getSelectedListItem();
			listItems = elements.getListItems();

			if (listItemSelected.length !== 0) {
				listItemSelected.removeClass('selected');
				var prevItem = listItemSelected.prevAll('md-list-item').eq(0);

				if (prevItem.length > 0) {
					listItemSelected = prevItem.addClass('selected');
				} else {
					listItemSelected = listItems.last().addClass('selected');
				}
			} else {
				listItemSelected = listItems.last().addClass('selected');
			}
		}

		function handleArrowRight() {
			_handleSelection();
			if (listItemSelected.length === 0 && search.searchText === '') {
				listItems = elements.getListItems();
				listItemSelected = listItems.eq(0).addClass('selected');
			}
		}

		function handleTab() {
			_handleSelection();
			if (listItemSelected.length === 0) {
				listItems = elements.getListItems();
				listItemSelected = listItems.eq(0).addClass('selected');
			}
		}

		function handleEnter() {
			_handleSelection();
			if (listItemSelected.length === 0) {
				search.performSearch();
			}
		}

		function handleBackspace() {}

		function handleEsc() {
			if (search.searchText) {
				search.clearInput();
			} else {
				search.close();
			}
		}

		function _handleSelection() {
			listItemSelected = elements.getSelectedListItem();
			if (listItemSelected.length !== 0) {
				listItemSelected.find('.md-button button').click();
				listItemSelected.removeClass('selected');
			}
		}
	}

	w.mx = w.mx || {};
	w.mx.shell = w.mx.shell || {};
	w.mx.shell.SearchHotkeysManager = mxSearchHotkeysManager;
})(window);
